import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { OMS_GRID_MONITORING_LAYOUT } from './OmsGridMonitoring';

export const OMS_GRID_MONITORING_LAYOUT_SPEC: LayoutSpec = {
  templateId: 'omsGrid',
  label: 'OMS Grid',
  id: 'omsGrid',
  dockViewLayout: OMS_GRID_MONITORING_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
